import React, { useContext, useEffect, useState } from 'react'
import { Link, Navigate, useNavigate } from "react-router-dom";

import { GetUserModel } from "../../ApiServices/Profile/ProfileApi";
import './PujaKit.css'
import toast from "react-hot-toast";
import LoginPopUp from "../LoginPopup";
import batuk from "../../assets/images/new/fav-removebg-preview.png";

import kitBox from "../../assets/images/new/pujaKitBox.jpg";
import Annual from "../../assets/images/new/Anual.jpg";
import Six from "../../assets/images/new/6-months.jpg";
import month from "../../assets/images/new/one-month.jpg";
import Queterly from "../../assets/images/new/Queterly.jpg";
import PujaKitFront from "../../assets/images/new/PujaKitFront.png";

import innerItem from "../../assets/images/new/pujaKit1.jpg";
import OpenBox from "../../assets/images/new/OpenBox.jpg";
import { PujaKitSubscriptionPlanList } from '../../ApiServices/PujaSubscription/PujaSubscriptionApi';
import { LoaderContext } from '../../AuthContext/AuthContext';

const PujaKitSubscriptionLandingPage = () => {
    const navigate = useNavigate();
    const [showProfile, setProfile] = useState(false);
    const [subscriptionDetails, setSubscriptionDetails] = useState([kitBox, innerItem, OpenBox,]);
    const { setLoader, loader } = useContext(LoaderContext);
    const [showOpenLoginModal, setShowOpenLoginModal] = useState(false);
    const userID = localStorage.getItem("userID");
    const [templeDetails, setTempleDetails] = useState([kitBox, innerItem, OpenBox]);
    const [cardImages, setCardImages] = useState([month, Queterly, Six, Annual]);
    const ItemAddedToast = () => toast("Please Update Your Profile");
    useEffect(() => {
        PujaKitSubscriptionPlanListData()
    }, [])

    const PujaKitSubscriptionPlanListData = async () => {
        setLoader(true)
        try {
            const response = await PujaKitSubscriptionPlanList(); // Call your API with the slug
            if (response?.ResponseCode === "0") {
                setLoader(false)

                setSubscriptionDetails(response.DATA); // Access DATA directly as an object


            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching temple details:", error);
        }
    }
    const packages = [
        {
            name: "Monthly Package",
            price: "₹499",
            description: "Essential puja items for monthly rituals.",
        },
        {
            name: "Quarterly Package",
            price: "₹1399",
            description: "Seasonal items with extra goodies.",
        },
        {
            name: "Annual Package",
            price: "₹4999",
            description: "Everything you need for year-round devotion.",
        },
    ];

    const handlePurchaseOrder = (pkg) => {
        console.log('pkg', pkg)
        if (userID === null || userID === undefined || userID === '') {
            setShowOpenLoginModal(true)
        } else {
            navigate("/puja-kit-details", {
                state: pkg,
            });
        }

    }

    const handleImageClick = (clickedIndex) => {
        if (clickedIndex === 0) return; // No change if the first image is clicked

        setTempleDetails(prevImages => {
            const newImages = [...prevImages];
            // Swap clicked image with the first image
            [newImages[0], newImages[clickedIndex]] = [newImages[clickedIndex], newImages[0]];
            return newImages;
        });
    };
    return (
        <>
            <div className="container-fluid px-3 px-md-5 py-3" style={{ fontFamily: "poppins" }}>
                {/* Row 1 - Image and Description */}
                <div className='sec-title text-left'>
                    <h6 className="sec-title__tagline bw-split-in-right"
                        style={{
                            perspective: "400px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                        <img className=" tagline-img" src={batuk} alt="" />
                        Kit Subscription Plan
                    </h6>
                    <h3 className="sec-title__title bw-split-in-left"
                        style={{ perspective: "400px", textAlign: "center" }}>
                        Puja Kit Subscription Plans
                    </h3>
                </div>

                <div className="row  justify-content-center align-items-center mb-3"  >

                    <div class="col-xl-12 pe-0  mb-3" style={{ border: "none", }}>
                        {/* <!-- No padding on the right --> */}
                        <div className="image-grid-container">
                            <div className="left-image card">
                                {templeDetails.length > 0 ? (
                                    <img
                                        src={templeDetails[0]}
                                        alt="Main Temple"
                                        style={{ margin: '0' }}
                                        className="zoom-image"
                                    />
                                ) : loader === false ? (
                                    <img src={kitBox} alt="Main" />
                                ) : ''}
                            </div>
                            {templeDetails?.length === 3 && (
                                <div className="right-images layout-3 " style={{ height: 'auto' }}>
                                    {templeDetails?.slice(1).map((image, index) => (
                                        <img

                                            key={index}
                                            src={image}
                                            alt={`Temple Image ${index + 2}`}
                                            onClick={() => handleImageClick(index + 1)}
                                            style={{ cursor: 'pointer', margin: '0', objectFit: 'fill' }}
                                            className='card'
                                        />
                                    ))}
                                </div>
                            )}

                            {templeDetails?.length === 4 && (
                                <div className="right-images layout-4">
                                    {templeDetails?.slice(1).map((image, index) => (
                                        <img
                                            style={{ margin: '0' }}
                                            key={index}
                                            src={image}
                                            alt={`Temple Image ${index + 2}`}
                                            className={`right-image ${index === 1 ? 'full-width' : ''}`}
                                        />
                                    ))}
                                </div>
                            )}


                            {templeDetails?.length === 2 && (
                                <div className="right-images" style={{ display: "block" }}>
                                    {templeDetails?.slice(1).map(
                                        (image, index) => (
                                            <img
                                                style={{ margin: '0' }}
                                                key={index}
                                                src={image}
                                                alt={`Temple Image ${index + 2}`} // Adjust index for alt text
                                            />
                                        )
                                    )}
                                </div>
                            )}
                            {templeDetails?.length === 5 && (
                                <div className="right-images layout-5">
                                    {templeDetails?.slice(1).map((image, index) => (
                                        <img
                                            style={{ margin: '0' }}
                                            key={index}
                                            src={image}
                                            alt={`Temple Image ${index + 2}`}
                                            className="right-image"
                                        />
                                    ))}
                                </div>
                            )}


                        </div>
                    </div>



                    {/* Description Section */}
                    <div className="col-lg-12">

                        <p style={{ fontSize: "16px", color: "#333" }}>
                            Stay connected to your spiritual journey with our thoughtfully prepared puja kits. Delivered to your home monthly, quarterly, or yearly, each kit contains the important items you need for daily or special rituals. Let Myomnamo help you perform your pooja with purity, peace, and ease. So you can focus on prayer, not preparation. Pick a subscription based on your worship needs.
                        </p>
                    </div>
                </div>




                {/* Subscription Cards */}
                <div
                    className="row g-4"
                    style={{
                        '--bs-gutter-x': '15px',
                        marginLeft: 0,
                        marginRight: 0,
                    }}
                >
                    {subscriptionDetails.map((pkg, index) => (
                        <div
                            className="col-12 col-sm-6 col-md-4 col-lg-3"
                            key={index}
                            onClick={() => handlePurchaseOrder(pkg)}
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <div
                                className="animated-border-card border rounded-4 d-flex flex-column justify-content-between gap-2 p-0"
                                style={{
                                    borderColor: "#f3ddbb",
                                    boxShadow: "0 1rem 3rem rgb(164 38 66 / 22%)",
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: '0',
                                }}
                            >
                                <div style={{ padding: '0px' }}>
                                    <div>
                                        <img
                                            src={cardImages[index]}
                                            className="img-fluid w-100 mb-2"
                                            alt={`Subscription ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                display: 'block',
                                                marginBottom: '8px',
                                            }}
                                        />
                                    </div>
                                    {Number(pkg.DiscountedAmount) > 0 ? (
                                        <p
                                            className="fw-bold fs-5 mb-1"
                                            style={{
                                                color: "#d6a300",
                                                marginBottom: '4px',
                                                fontSize: '1.25rem',
                                                textAlign: 'center',
                                                display: 'block', // Ensures centering even inside flex parents
                                                width: '100%',    // Makes sure it's centered inside column
                                            }}
                                        >
                                            ₹ {Math.round(Number(pkg.Price) - Number(pkg?.DiscountedAmount))}{' '}
                                            <span
                                                style={{
                                                    fontSize: '12px',
                                                    textDecoration: 'line-through',
                                                }}
                                            >
                                                ₹{Math.round(Number(pkg.Price))}
                                            </span>
                                        </p>
                                    ) : (
                                        <p
                                            className="fw-bold fs-5 mb-1"
                                            style={{
                                                color: "#d6a300",
                                                marginBottom: '4px',
                                                fontSize: '1.25rem',
                                                textAlign: 'center',
                                                display: 'block', // Ensures centering even inside flex parents
                                                width: '100%',    // Makes sure it's centered inside column
                                            }}
                                        >
                                            ₹ {Math.round(Number(pkg.Price))}
                                        </p>

                                    )}

                                    <div
                                        style={{
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            lineHeight: '1.5',
                                            paddingRight: '5px'
                                        }}
                                        dangerouslySetInnerHTML={{ __html: pkg?.Description }}
                                    />
                                </div>

                                <div
                                    className="d-flex justify-content-center mt-auto mb-2 text-center"
                                    style={{
                                        padding: '12px',
                                        marginTop: 'auto',
                                        textAlign: 'center',
                                    }}
                                >
                                    <button
                                        className="Normal-app-btn"
                                        onClick={() => handlePurchaseOrder(pkg)}

                                        style={{ padding: '6px 16px', fontSize: '14px' }}
                                    >
                                        Purchase Now
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            {showOpenLoginModal && (
                <LoginPopUp show={showOpenLoginModal} onHide={() => setShowOpenLoginModal(false)} />
            )}
        </>
    )
}

export default PujaKitSubscriptionLandingPage
